var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClocko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1757471548067,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14566,
    width: 14,
    height: 14,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M585.12 310.848l0 256q0 8-5.152 13.152t-13.152 5.152l-182.848 0q-8 0-13.152-5.152t-5.152-13.152l0-36.576q0-8 5.152-13.152t13.152-5.152l128 0 0-201.152q0-8 5.152-13.152t13.152-5.152l36.576 0q8 0 13.152 5.152t5.152 13.152zM822.848 512q0-84.576-41.728-156t-113.152-113.152-156-41.728-156 41.728-113.152 113.152-41.728 156 41.728 156 113.152 113.152 156 41.728 156-41.728 113.152-113.152 41.728-156zM950.848 512q0 119.424-58.848 220.288t-159.712 159.712-220.288 58.848-220.288-58.848-159.712-159.712-58.848-220.288 58.848-220.288 159.712-159.712 220.288-58.848 220.288 58.848 159.712 159.712 58.848 220.288z",
    "p-id": 14567,
    fill: "#2563eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClocko);
export default __webpack_public_path__ + "static/media/clocko.802aa72a.svg";
export { ForwardRef as ReactComponent };